import { render, staticRenderFns } from "./LicenseTerms.vue?vue&type=template&id=8cca59f0"
import script from "./LicenseTerms.vue?vue&type=script&lang=js"
export * from "./LicenseTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports